import {
	Alert as AlertMui
} from '@mui/material';
import { ChildrenProps, appendClassName } from '@componentLibraryWrapper/common';
import './alert.scss';

export type AlertSeverity = 'success' | 'error' | 'info' | 'warning';

export interface AlertProps extends ChildrenProps<HTMLDivElement> {
	severity?: AlertSeverity,
}

const Alert = ({
	className,
	severity='success',
	...rest
}: AlertProps) => {
	return (
		<AlertMui
			{...rest}
			className={appendClassName('sm-alert', className)}
			severity={severity}/>
	)
}

export default Alert;